import {makeReactContext} from 'lib/makeReactContext';
import {Method} from 'procedures/ProcedureDomainTypes';
import {ProcedurePauseCondition} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/redux/reduceFlowchartConfig';

interface MethodSidepanelContextValue {
  saveImmediately: ((methodData: Method) => void) | null;
  pauseAutosaver: ((condition: ProcedurePauseCondition, value: boolean) => void) | null;
}

const MethodSidepanelContext = makeReactContext<MethodSidepanelContextValue>(
  () => ({
    // This context will not be available in legacy procedures; callers can check for null to determine
    // whether to use this saveImmediately or the one provided by ProcedurePageContext
    saveImmediately: null,
    pauseAutosaver: null,
  }),
  'MethodSidepanelContext'
);

export default MethodSidepanelContext;
